var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "siderbar",
      class: { minWidth: _vm.isCollapse },
      style: { background: _vm.menuConfig.menu_background_color }
    },
    [
      _c(
        "el-scrollbar",
        [
          _c(
            "el-menu",
            {
              staticClass: "el-menu-vertical-demo",
              attrs: {
                "default-active": _vm.activeRoutePath,
                "background-color": _vm.menuConfig.menu_background_color,
                "text-color": _vm.menuConfig.menu_text_color,
                "active-text-color": _vm.menuConfig.menu_ctive_text_color,
                mode: "vertical",
                "collapse-transition": false,
                collapse: _vm.isCollapse,
                router: ""
              }
            },
            [
              _vm._l(_vm.myRoutes, function(item) {
                return [
                  !item.children || item.children.length == 0
                    ? [
                        _c(
                          "el-menu-item",
                          {
                            key: item.meta.title,
                            ref: item.name,
                            refInFor: true,
                            class: item.name,
                            attrs: { index: item.path }
                          },
                          [
                            _c("i", {
                              class: ["iconfont", "menu-icon", item.meta.icon],
                              staticStyle: { color: "#FFF" }
                            }),
                            _c(
                              "span",
                              { attrs: { slot: "title" }, slot: "title" },
                              [_vm._v(_vm._s(item.meta.title))]
                            )
                          ]
                        )
                      ]
                    : _vm._e(),
                  item.children.length > 0
                    ? [
                        _c(
                          "el-submenu",
                          { key: item.meta.title, attrs: { index: item.path } },
                          [
                            _c("template", { slot: "title" }, [
                              _c("i", {
                                class: [
                                  "iconfont",
                                  "menu-icon",
                                  item.meta.icon
                                ],
                                staticStyle: { color: "#FFF" }
                              }),
                              _c(
                                "span",
                                { attrs: { slot: "title" }, slot: "title" },
                                [_vm._v(_vm._s(item.meta.title))]
                              )
                            ]),
                            _vm._l(item.children, function(code, codeindex) {
                              return _c(
                                "el-menu-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !code.hidden,
                                      expression: "!code.hidden"
                                    }
                                  ],
                                  key: codeindex,
                                  class: ["children-menu"],
                                  attrs: { index: code.path }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(code.meta.title) +
                                      "\n            "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }